import { enUS, he, id } from 'date-fns/locale'

import { AppFilterValueState, initialAppFilterValueState } from '@/context/OrgAppsContext'

export function getLocale(lang: 'en' | 'id' | 'he' | undefined) {
  switch (lang) {
    case 'en':
      return enUS
    case 'he':
      return he
    case 'id':
      return id
    default:
      return undefined
  }
}

export function isFilterActive(currentState: AppFilterValueState) {
  return (
    initialAppFilterValueState.plan !== currentState.plan ||
    initialAppFilterValueState.status !== currentState.status ||
    initialAppFilterValueState.favorite !== currentState.favorite ||
    initialAppFilterValueState.team.id !== currentState.team.id
  )
}
